export default [
    {
        path: '/hr/employees',
        name: 'employees',
        props: true,
        component: () => import('@/views/hr/employees/index.vue'),
        meta: {
            pageTitle: 'Employees',
            breadcrumb: [
                {
                text: 'Employees',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/employees/add',
        name: 'create-employees',
        component: () => import('@/views/hr/employees/create.vue'),
        meta: {
            pageTitle: 'Create Employee',
            breadcrumb: [
                {
                text: 'Employees',
                to: { name: 'employees' },
                },
                {
                text: 'Create Employee',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/employees/:id',
        name: 'detail-employees',
        props: true,
        component: () => import('@/views/hr/employees/detail.vue'),
        meta: {
            pageTitle: 'Detail Employee',
            breadcrumb: [
                {
                text: 'Employees',
                to: { name: 'employees' },
                },
                {
                text: 'Detail Employee',
                active: true,
                },
            ],
        },
    },
]